const cabecera = () => {
    const botonVideo = document.querySelector('.cabecera__video__enlace button');
    if (!botonVideo) {
        return;
    }
    const modal = document.querySelector('.cabecera__video');
    const cerrar = modal.querySelector('.cabecera__video__cerrar');
    const cierraModal = () => {
        modal.close();
        modal.remove();
    };
    botonVideo.addEventListener('click', () => {
        document.documentElement.appendChild(modal);
        modal.showModal();
    });
    cerrar.addEventListener('click', cierraModal);
    modal.addEventListener('click', e => {
        if (e.target === modal) {
            cierraModal();
        }
    });
    modal.remove();
};
export default cabecera;
